import React, { useEffect, useState } from "react";
import { FormControl, MenuItem } from "@material-ui/core";
import { TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import { fetchConToken } from "../../helpers/fetch";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { armarParametros } from "../../helpers/parametros";
import { useDispatch } from "react-redux";
import { startAlerta } from "../../actions/ui/alertas";

export const CboEspecialidades = (props) => {
  const { idCentroMedico, idProfesional, cargarEnCascada, setIdEspecialidad, cargarHorarios, manejadorInputChange, valor, idTipoParametrizacion, cargaAfiliado, porProfesional, edadAfiliado, filtrarEdad } = props;
  const [labelShrink, setLabelShrink] = useState(false);
  const [listaNac, setListaNac] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const traerDatos = async () => {
      try {
        const parametros = armarParametros(null, idCentroMedico, idProfesional, null, null, null, null, null, null, null, null, null, null, filtrarEdad && edadAfiliado);
        const response = cargaAfiliado
          ?
          await fetchConToken(`Especialidades/traerParaAfiliado?edadAfiliado=${edadAfiliado}`)
          :
          (cargarEnCascada
            ?
            (porProfesional
              ?
              await fetchConToken(`Especialidades/traerPorProfesional?${parametros}`)
              :
              await fetchConToken(`Especialidades/traerPorParametros?${parametros}`)
            )
            :
            await fetchConToken(`Especialidades/traerParaCallCenter?${parametros}`)
          );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          if (lista) {
            let listaFromApi = lista.map((item) => {
              return {
                value: item.idEspecialidades,
                display: item.descripcionEspecialidades,
              };
            });
            setListaNac(listaFromApi);
            if (lista.length === 1 && cargarEnCascada && !cargaAfiliado) {
              setLabelShrink(true);
              porProfesional ? manejadorInputChange({ target: { name: 'idEspecialidad', value: lista[0].idEspecialidades } }) : setIdEspecialidad(lista[0].idEspecialidades);
              // cargarHorarios&& dispatch( fetchEfectorHorarios(idCentroMedico, idProfesional, lista[0].idEspecialidades, idTipoParametrizacion) );
            }
          }
        }
      } catch (err) {
        setListaNac([]);
        console.log(`¡Error! -> ${err}`);
        dispatch(startAlerta('Ocurrio un error al cargar las Especialidades', "warning", `¡Error!`));
      }
    };
    if ((cargarEnCascada && (idCentroMedico === null || idProfesional === null) && !porProfesional) || (cargarEnCascada && (idProfesional === null) && porProfesional))
      setListaNac([]);
    else
      traerDatos();
  }, [dispatch, idCentroMedico, idProfesional, cargarEnCascada, setIdEspecialidad, cargarHorarios, idTipoParametrizacion, cargaAfiliado, edadAfiliado, filtrarEdad, porProfesional, manejadorInputChange]);

  const inputChange = e => {
    manejadorInputChange(e);
    e.target.value ? setLabelShrink(true) : setLabelShrink(false);
  }

  return (
    <>
      {cargarEnCascada
        ?
        <FormControl
          margin="normal"
          fullWidth={true}
        >
          <SelectValidator
            onChange={(e) => {
              inputChange(e);
            }}
            label="Especialidad"
            name="idEspecialidad"
            value={valor}
            fullWidth={true}
            validators={props.required === undefined ? ['required'] : props.required}
            errorMessages={['Seleccione una opción']}
            InputLabelProps={{
              shrink: labelShrink,
            }}
          >
            <MenuItem value={null}>
              <em>Seleccione</em>
            </MenuItem>
            {listaNac.map((nac) => (
              <MenuItem key={nac.value} value={nac.value}>
                {nac.display}
              </MenuItem>
            ))}
          </SelectValidator>
        </FormControl>
        :
        <FormControl
          margin="normal"
          fullWidth={true}
        >
          {valor
            ?
            listaNac.length > 0 &&
            <Autocomplete
              id="combo-box-demo"
              options={listaNac}
              value={listaNac.find(e => e.value === valor)}
              onChange={(e, selected) => {
                manejadorInputChange({ target: { name: 'idEspecialidad', value: selected !== null ? selected?.value : null } });
              }}
              getOptionLabel={(option) => option.display}
              renderInput={
                (params) =>
                  <TextValidator
                    {...params}
                    value={valor}
                    label="Especialidad"
                    validators={['required']}
                    errorMessages={['Seleccione una opción']}
                  />
              }
            />
            :
            <Autocomplete
              id="combo-box-demo"
              options={listaNac}
              value={null}
              onChange={(e, selected) => {
                manejadorInputChange({ target: { name: 'idEspecialidad', value: selected !== null ? selected?.value : null } });
              }}
              getOptionLabel={(option) => option.display}
              renderInput={
                (params) =>
                  <TextValidator
                    {...params}
                    value={valor}
                    label="Especialidad"
                    validators={['required']}
                    errorMessages={['Seleccione una opción']}
                  />
              }
            />
          }
        </FormControl>
      }
    </>
  );
};
